import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import NumberRow from '#components/m/MeineAusbildung/NumberRow'
import HorizontalRule from '#components/a/HorizontalRule'
import NachweisListe from '#components/o/NachweisListe/NachweisListe'
import ProgressOverview from '#components/o/MeineAusbildung/ProgressOverview'

export default function Ausbildungsnachweise(props) {
  const {
    percentageSubmittedNachweiseVersusTotalAmount,
    numbersDashboard,
    lastModifiedNachweise,
    lastStatusChangedNachweise,
  } = props

  const showEmptyTile = !numbersDashboard || !lastModifiedNachweise || !lastStatusChangedNachweise

  if (showEmptyTile) {
    return <EmptyTile />
  }

  return (
    <ProgressOverview
      titleKey="menu_item_ausbildungsnachweise"
      percentage={percentageSubmittedNachweiseVersusTotalAmount}
    >
      <div data-testid="ausbildungsnachweisedashboard" className="ausbildungsnachweise">
        <NumberRow numbers={sortNumbers(numbersDashboard)} />
        <HorizontalRule />
        <span className="title">{i18n.t('last_modified')}</span>
        <NachweisListe
          ausbildungsnachweise={lastModifiedNachweise}
          modifier="dashboard_lastmodified"
          canVerify={false}
        />
        <span className="title">{i18n.t('newest_reactions')}</span>
        <NachweisListe
          className="dashboard--lastreactions"
          ausbildungsnachweise={lastStatusChangedNachweise}
          modifier="dashboard_newestreactions"
          canVerify={false}
        />
      </div>
    </ProgressOverview>
  )
}

function sortNumbers(numbers) {
  const sortedNumbers = [
    {color: 'green', value: numbers.confirmedItems, label: 'confirmed_items'},
    {color: 'blue', value: numbers.submittedItems, label: 'submitted_items'},
    {color: 'red', value: numbers.rejectedItems, label: 'rejected_items'},
    {color: 'grey', value: numbers.draftItems, label: 'draft_items'},
  ]

  return sortedNumbers
}

function EmptyTile() {
  return (
    <ProgressOverview titleKey="menu_item_ausbildungsnachweise" showProgressbar={false}>
      <div data-testid="ausbildungsnachweisedashboardNoData" className="ausbildungsnachweise">
        <span>{i18n.t('loading_dashboard_data_failed')}</span>
      </div>
    </ProgressOverview>
  )
}

Ausbildungsnachweise.propTypes = {
  percentageSubmittedNachweiseVersusTotalAmount: PropTypes.number,
  numbersDashboard: PropTypes.shape({
    confirmedItems: PropTypes.number,
    submittedItems: PropTypes.number,
    rejectedItems: PropTypes.number,
    draftItems: PropTypes.number,
  }),
  lastModifiedNachweise: PropTypes.array,
  lastStatusChangedNachweise: PropTypes.array,
}
